import { useMemo, useState } from "react";
import { motion } from "framer-motion";
import { ListOrdered, Plus, Undo2, ArrowRight } from "lucide-react";
import { useLang } from "../../context/LanguageContext";

export const OrderBlock = ({ block, onDone }) => {
  const { t } = useLang();
  const pool0 = useMemo(() => [...block.steps].sort(() => Math.random() - 0.5), [block]);
  const [order, setOrder] = useState([]);
  const pool = pool0.filter((s) => !order.includes(s));

  return (
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="card-dark p-7 sm:p-10" data-testid="learn-block-order">
      <span className="badge-lime inline-flex items-center gap-2"><ListOrdered className="w-3.5 h-3.5" /> {t("learn.exercise")}</span>
      <h2 className="font-heading font-black text-xl sm:text-2xl text-[#0B1B3A] mt-5 leading-snug" data-testid="learn-order-prompt">{block.prompt}</h2>

      <div className="mt-7 space-y-2 min-h-[56px]" data-testid="learn-order-list">
        {order.length === 0 && <p className="text-sm text-[#94A3B8]">{t("games.pickSteps")}</p>}
        {order.map((s, i) => (
          <div key={s} className="flex items-center gap-3 rounded-[16px] bg-[#EEF4FF] px-4 py-3">
            <span className="w-7 h-7 rounded-full bg-[#1D4ED8] text-white text-xs font-bold flex items-center justify-center">{i + 1}</span>
            <span className="flex-1 text-sm font-semibold text-[#0B1B3A]">{s}</span>
          </div>
        ))}
      </div>

      <div className="flex flex-wrap gap-2 mt-7" data-testid="learn-order-pool">
        {pool.map((s) => (
          <button
            key={s}
            data-testid={`learn-order-step-${block.steps.indexOf(s)}`}
            onClick={() => setOrder([...order, s])}
            className="inline-flex items-center gap-2 rounded-full border border-[#E2E8F0] px-4 py-2 text-sm font-semibold text-[#1E293B] hover:border-[#1D4ED8] hover:bg-[#EEF4FF] transition-colors duration-200"
          >
            <Plus className="w-3.5 h-3.5" /> {s}
          </button>
        ))}
      </div>

      <div className="flex flex-wrap gap-3 mt-8">
        <button data-testid="learn-order-undo" disabled={order.length === 0} onClick={() => setOrder(order.slice(0, -1))} className="btn-outline-light disabled:opacity-50">
          <Undo2 className="w-4 h-4" /> {t("games.undo")}
        </button>
        <button data-testid="learn-order-submit" disabled={pool.length > 0} onClick={() => onDone(order)} className="btn-blue disabled:opacity-50">
          {t("learn.continue")} <ArrowRight className="w-4 h-4" />
        </button>
      </div>
      {block.explanation && pool.length === 0 && <p className="text-xs text-[#64748B] mt-5">{block.explanation}</p>}
    </motion.div>
  );
};

export default OrderBlock;
